(function () {
  var SELECTOR = '[data-palpa-sponge-hero]';

  function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v;
  }

  function ease(t) {
    return t * t * (3 - 2 * t);
  }

  function setup(root) {
    if (root.dataset.psshReady === 'true') return;
    root.dataset.psshReady = 'true';

    var stage = root.querySelector('.pssh__stage');
    var hero = root.querySelector('.pssh__hero');
    var panel = root.querySelector('.pssh__panel');
    if (!stage) return;

    var stageHeight = 0;
    var queued = false;
    var active = false;

    function measure() {
      stageHeight = stage.offsetHeight;
    }

    function apply() {
      queued = false;
      var rect = root.getBoundingClientRect();
      var travel = rect.height - stageHeight;
      var p = travel > 0 ? clamp(-rect.top / travel, 0, 1) : 0;

      var pHero = ease(clamp(p / 0.28, 0, 1));
      var pPanel = ease(clamp((p - 0.56) / 0.26, 0, 1));

      root.style.setProperty('--pssh-hero', pHero.toFixed(4));
      root.style.setProperty('--pssh-a', ease(clamp(p / 0.42, 0, 1)).toFixed(4));
      root.style.setProperty('--pssh-b', ease(clamp((p - 0.12) / 0.46, 0, 1)).toFixed(4));
      root.style.setProperty('--pssh-panel', pPanel.toFixed(4));

      if (hero) hero.dataset.hidden = pHero > 0.999 ? 'true' : 'false';
      if (panel) panel.dataset.hidden = pPanel < 0.001 ? 'true' : 'false';
    }

    function request() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(apply);
    }

    function onResize() {
      measure();
      request();
    }

    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible === active) return;
      active = visible;
      if (visible) {
        window.addEventListener('scroll', request, { passive: true });
        onResize();
      } else {
        window.removeEventListener('scroll', request);
      }
    }).observe(root);

    window.addEventListener('resize', onResize, { passive: true });
    measure();
    apply();
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
